import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Clock } from 'lucide-react';

const TrialBanner = ({ trialInfo }) => {
  const navigate = useNavigate();

  // Only show if trial is active and has 7 or fewer days remaining
  if (!trialInfo?.isTrialActive || trialInfo?.daysRemaining > 7) {
    return null;
  }

  return (
    <div className="bg-gradient-to-r from-amber-500 to-orange-500 text-white px-4 py-3">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Clock className="w-5 h-5" />
          <span className="font-medium">
            {trialInfo.daysRemaining === 0 
              ? "Your trial ends today!" 
              : trialInfo.daysRemaining === 1
                ? "Only 1 day left in your trial!"
                : `${trialInfo.daysRemaining} days left in your free trial`
            }
          </span>
        </div>
        <Button 
          size="sm" 
          variant="secondary"
          className="bg-white text-orange-600 hover:bg-orange-50"
          onClick={() => navigate('/signup?upgrade=true')}
        >
          Upgrade Now
        </Button>
      </div>
    </div>
  );
};

export default TrialBanner;
